import { useNavigate } from "react-router-dom";
import CardHeaderBackgroundComponent from "../../../components/cardHeaderBackground";
import ContainerComponent from "../../../components/conatiner";
import HeaderComponent from "../../../components/header";
import InputComponent from "../../../components/input";
import { ChangeEvent, useEffect, useState } from "react";
import TableComponent from "../../../components/table";
import { ManagersCostCentersService } from "../../../services/managers/cost_centers";
import { ToastErro } from "../../../components/toast";

const ManagersCostCentersPage = () => {

    const navigate = useNavigate();

    const [loading, setLoading] = useState<boolean>(true);

    const [costCenters, setCostCenters] = useState<any>([]);
    const [isAdmin, setIsAdmin] = useState<boolean>(false);

    // variaveis de pesquisa
    const [description, setDescription] = useState<string>('');
    const [page, setPage] = useState<number>(1);
    // variaveis de pesquisa

    // função para pesquisar centros de custo do gerente
    const getCostCenters = async () => {

        setLoading(true);

        await ManagersCostCentersService(description, page).then(resp => {
            setCostCenters(resp.data.cost_centers);
            setIsAdmin(resp.data.is_admin);
        }).catch(error => {
            ToastErro(error?.response?.data?.message);
        });

        setLoading(false);

    }
    // função para pesquisar centros de custo do gerente

    useEffect(() => {
        getCostCenters();
    }, [page]);

    return (
        <>
            <HeaderComponent
                title="Centros de Custo"
            />
            <ContainerComponent>
                <>
                    <CardHeaderBackgroundComponent
                        title="Pesquisar"
                    >
                        <div className="row">
                            <InputComponent
                                label="Descrição"
                                col={8}
                                size={"small"}
                                defaultValue={description}
                                onChange={(e: ChangeEvent<HTMLInputElement>) => setDescription(e.target.value)}
                            />
                            <div className="col-md-4">
                                <button className="btn btn-primary" type="button" onClick={() => page > 1 ? setPage(1) : getCostCenters()}>Pesquisar</button>
                                <button className="btn btn-danger" type="button" style={{ marginLeft: 15 }} onClick={() => (window as any).location.reload()}>Limpar</button>
                            </div>
                        </div>
                    </CardHeaderBackgroundComponent>

                    <TableComponent
                        title="Centros de Custo"
                        columns={['ID', 'Descrição','CC','Filial', 'Qtd. Níveis de Aprovação', 'Ações']}
                        loading={loading}
                        page={page}
                        last_page={costCenters?.last_page}
                        onClickPagination={(e: ChangeEvent<unknown>, value: number) => setPage(value)}
                    >
                        {
                            costCenters?.data?.map((c: any) => {
                                return (
                                    <tr key={c.id}>
                                        <td className="px-4">{c.id}</td>
                                        <td className="px-4">{c.description}</td>
                                        <td className="px-4">{c.code}</td>
                                        <td className="px-4">{c.branch}</td>
                                        <td className="px-4">{c.approval_levels}</td>
                                        <td className="px-4">
                                            <button className="btn btn-text-success" type="button" title="Funcionários" onClick={() => navigate(`/managers/cost_centers/employees/${c.id}`)}><i className="material-icons">person</i></button>
                                            {isAdmin && <button className="btn btn-text-info" type="button" title="Informações" onClick={() => navigate(`/managers/cost_centers/${c.id}`)}><i className="material-icons">info</i></button>}
                                        </td>
                                    </tr>
                                );
                            })
                        }
                    </TableComponent>
                </>
            </ContainerComponent>
        </>
    );

}

export default ManagersCostCentersPage;